import { createContext } from 'react';
import { defaultContextValue } from './default';
import { UIStateContextValue } from './types';

export const UIStateContext = createContext<UIStateContextValue>(defaultContextValue);

